// Lista de piezas serializadas por identificar antes del cierre: un campo por pieza con sugerencias
// y la confirmación que libera el cierre.
import { Check } from 'lucide-react';
import { Button } from '@/kit';
import type { SaleClosing } from './useSaleClosing';
import { IdentifierField } from './IdentifierField';
import { pinFailureAboutPieces } from '../../piecesErrors';

export function PieceIdentifiers({
    sessionId,
    closing,
    disabled = false,
    showConfirm = true,
}: {
    sessionId: string;
    closing: Pick<
        SaleClosing,
        | 'pieces'
        | 'captured'
        | 'setPiece'
        | 'fieldErrors'
        | 'failure'
        | 'piecesReady'
        | 'piecesConfirmed'
        | 'confirmPieces'
        | 'pinFailure'
        | 'pinning'
    >;
    disabled?: boolean;
    /** Sin botón propio cuando otra acción fija las piezas (el IMEI en crédito). */
    showConfirm?: boolean;
}) {
    const { pieces, captured, setPiece, fieldErrors, failure, pinFailure } = closing;
    // Sin pieza señalada (p. ej. IDENTIFIER_NOT_AVAILABLE) el aviso va sobre la lista entera.
    const listError = pinFailure
        ? pinFailureAboutPieces(pinFailure) && !pinFailure.target
            ? pinFailure.message
            : null
        : failure?.aboutPieces && !failure.target
          ? failure.message
          : null;

    return (
        <div className="flex flex-col gap-3">
            {pieces.map((piece) => (
                <IdentifierField
                    key={piece.key}
                    sessionId={sessionId}
                    lineId={piece.lineId}
                    sku={piece.sku}
                    mode={piece.trackingMode}
                    label={piece.label}
                    value={captured[piece.key] ?? ''}
                    onChange={(value) => {
                        setPiece(piece.key, value);
                    }}
                    error={fieldErrors[piece.key]}
                    disabled={disabled}
                />
            ))}
            <div className="flex items-center justify-end gap-2">
                {closing.piecesConfirmed ? (
                    <span className="flex items-center gap-1 text-[11.5px] font-semibold text-success">
                        <Check className="size-3" strokeWidth={3} aria-hidden /> Piezas confirmadas
                    </span>
                ) : (
                    showConfirm && (
                        <Button
                            size="sm"
                            disabled={disabled || !closing.piecesReady}
                            isLoading={closing.pinning}
                            onClick={closing.confirmPieces}
                        >
                            Confirmar piezas
                        </Button>
                    )
                )}
            </div>
            {listError && (
                <p role="alert" className="text-[11.5px] text-destructive">
                    {listError}
                </p>
            )}
        </div>
    );
}
